
import { Component, Prop, Vue } from 'vue-property-decorator';
import { MediaItem, MediaType } from '../../backend/backendapi';
import MediaPicker from '../../mediapicker/MediaPicker';

@Component({
  components: {
    MediaPicker,
  },
})
export default class ImageSelector extends Vue {
  @Prop({ default: false })
  disabled!: boolean;

  async onSelected(e: MediaItem): Promise<void> {
    if (e.type !== 'Image') { //MediaType.Image
      return;
    }

    this.$emit('input', e);
  }

  openMediaPicker(): void {
    (this.$refs.mediaPicker as MediaPicker).openCurrentFolder(() => {
    }, MediaType.Image);
  }
}
